import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { MoneyInput, Notice, parseMoney } from "../../lib/ui";

/* Register an employee – port of employerAdd.php (API: POST /api/hr/employees, multipart). Admin only. Photo: JPG/PNG/WebP/GIF under 5 MB. */

const BLANK = { client_id: "", dob: "", hire_date: "", position: "", salary: "", end_date: "", status: "Active" };

export default function EmployeeRegister() {
  const api = useApi();
  const [clients, setClients] = useState([]);
  const [q, setQ] = useState("");
  const [f, setF] = useState(BLANK);
  const [photo, setPhoto] = useState(null);
  const [preview, setPreview] = useState(null);
  const [notice, setNotice] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/api/clients").then(setClients).catch((e) => setNotice({ tone: "err", text: e.message })); }, [api]);
  const matches = useMemo(() => clients.filter((c) => !q || c.name.toLowerCase().includes(q.toLowerCase())).slice(0, 100), [clients, q]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const pick = (e) => { const file = e.target.files?.[0] || null; setPhoto(file); setPreview(file ? URL.createObjectURL(file) : null); };
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setNotice(null);
    const body = new FormData();
    Object.entries({ ...f, salary: parseMoney(f.salary) }).forEach(([k, v]) => body.append(k, v ?? ""));
    if (photo) body.append("photo", photo);
    try {
      const res = await fetch(`${api.base}/api/hr/employees`, { method: "POST", body, credentials: "include" });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || data.error || `server replied ${res.status}`);
      setNotice({ tone: "ok", text: data.message }); setF(BLANK); setPhoto(null); setPreview(null); setQ("");
    } catch (err) { setNotice({ tone: "err", text: err.message }); }
    finally { setBusy(false); }
  };
  return (
    <main className="pg" style={{ maxWidth: "56rem" }}>
      <PageHeader slug="employerAdd" actions={<Link to="/addEmployee" className="btn"><i className="fas fa-users" /> Employee list</Link>} />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <form className="panel form" onSubmit={submit} style={{ maxWidth: "none" }}>
        <div className="field wide"><label htmlFor="er-q">Staff name<span className="req">*</span></label>
          <input id="er-q" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Type to find the person (they must exist as a client)" />
          <select aria-label="Staff member" required value={f.client_id} onChange={set("client_id")} size={Math.min(6, Math.max(2, matches.length))} style={{ marginTop: ".4rem" }}>
            {matches.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
        <div className="field wide"><label htmlFor="er-ph">Profile photo</label>
          <div style={{ display: "flex", alignItems: "center", gap: ".8rem" }}>
            {preview ? <img src={preview} alt="" style={{ width: "3.5rem", height: "3.5rem", objectFit: "cover", borderRadius: ".8rem" }} /> : <span className="avatar" style={{ width: "3.5rem", height: "3.5rem", borderRadius: ".8rem" }}><i className="fas fa-user" /></span>}
            <input id="er-ph" type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={pick} /></div></div>
        <div className="field"><label htmlFor="er-dob">Date of birth<span className="req">*</span></label><input id="er-dob" type="date" required value={f.dob} onChange={set("dob")} /></div>
        <div className="field"><label htmlFor="er-h">Hire date<span className="req">*</span></label><input id="er-h" type="date" required value={f.hire_date} onChange={set("hire_date")} /></div>
        <div className="field"><label htmlFor="er-p">Position<span className="req">*</span></label><input id="er-p" required value={f.position} onChange={set("position")} placeholder="e.g. Cashier" /></div>
        <div className="field"><label htmlFor="er-s">Salary (TZS)<span className="req">*</span></label><MoneyInput id="er-s" required value={f.salary} onChange={(v) => setF({ ...f, salary: v })} /></div>
        <div className="field"><label htmlFor="er-e">End date (if applicable)</label><input id="er-e" type="date" value={f.end_date} onChange={set("end_date")} /></div>
        <div className="field"><label htmlFor="er-st">Employment status<span className="req">*</span></label><select id="er-st" value={f.status} onChange={set("status")}>
          {["Active", "Inactive", "Resigned", "Terminated"].map((s) => <option key={s}>{s}</option>)}</select></div>
        <div className="form-actions"><button type="submit" className="btn primary" disabled={busy}><i className="fas fa-user-plus" /> {busy ? "Saving…" : "Register employee"}</button></div>
      </form>
    </main>
  );
}
